import { render, staticRenderFns } from "./CenterOfGravity.vue?vue&type=template&id=4c1979a8&scoped=true"
import script from "./CenterOfGravity.vue?vue&type=script&lang=js"
export * from "./CenterOfGravity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1979a8",
  null
  
)

export default component.exports